module.exports = __webpack_public_path__ + "img/button_language_uk.1dcacadd.svg";